export const isClient = (): boolean => {
  return import.meta.client
}
